import { StatusTypes, UserTypes } from 'types/GlobalTypes';

import { BooleanColorsDictionary, DefaultTrackingDiagnosticSessionTypeColor, DefaultTrackingDiagnosticTypeColor, TrackingDiagnosticsSessionTypePalette, TrackingDiagnosticsTypePalette, TypeColorsDictionary, UserDiagnosticsStateColorsDictionary, UserDiagnosticsTagColorsDictionary } from './Constants';
import { UserDiagnosticsState, UserDiagnosticsTag } from 'types/models/UserDiagnosticsModel';
import { createColorAssignerFactory } from './ColorFactory';

/**
 * @param type: type
 * @returns 'color
 */

export const getColor = (type: UserTypes | StatusTypes | null) => TypeColorsDictionary[type?.toLowerCase() || 'Other'];
export const getUserDiagnoticsStateColor = (state: UserDiagnosticsState) => UserDiagnosticsStateColorsDictionary[state];
export const getUserDiagnoticsTagColor = (state: UserDiagnosticsTag) => UserDiagnosticsTagColorsDictionary[state];

const _trackingDiagnosticsTypeAssigner = createColorAssignerFactory(TrackingDiagnosticsTypePalette, DefaultTrackingDiagnosticTypeColor);
export const assignTrackingDiagnosticsTypeColors = _trackingDiagnosticsTypeAssigner.assign;
export const getTrackingDiagnosticsTypeColor = _trackingDiagnosticsTypeAssigner.getColorFor;

const _trackingDiagnosticsSessionTypeAssigner = createColorAssignerFactory(TrackingDiagnosticsSessionTypePalette, DefaultTrackingDiagnosticSessionTypeColor);
export const assignTrackingDiagnosticsSessionTypeColors = _trackingDiagnosticsSessionTypeAssigner.assign;
export const getTrackingDiagnosticsSessionTypeColor = _trackingDiagnosticsSessionTypeAssigner.getColorFor;

export const getBooleanColor = (value: boolean | null, trueIsGreen: boolean) => {
  if (value === null) return BooleanColorsDictionary['null'];

  const trueKey = 'true';
  const falseKey = 'false';

  //normal mapping: true -> green, false -> red
  if (trueIsGreen) {
    return BooleanColorsDictionary[value ? trueKey : falseKey];
  }

  //inverted mapping: true -> red, false -> green
  return BooleanColorsDictionary[value ? falseKey : trueKey];
};

// =================

export const downloadFile = (blob: Blob, filename: string): boolean => {
  const link = document.createElement("a");
  if (link.download !== undefined) {
    let url = URL.createObjectURL(blob);
    
    link.setAttribute("href", url);
    link.setAttribute("download", filename);
    link.style.visibility = 'hidden';
    
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    return true;
  }

  return false;
}